import React from 'react';
import PropTypes from 'prop-types';
import ProductListRow from './item-list-row.js';

const MemoizedProductListRow = React.memo(ProductListRow, (prevProps, nextProps) => {
  // Only re-render if items array actually changed (deep comparison for first few items)
  if (prevProps.items.length !== nextProps.items.length) {
    return false;
  }
  
  // Compare first few items for changes (most important for performance)
  const itemsToCompare = Math.min(5, prevProps.items.length);
  for (let i = 0; i < itemsToCompare; i++) {
    if (prevProps.items[i]?.id !== nextProps.items[i]?.id) {
      return false;
    }
  }
  
  // Compare other props
  return (
    prevProps.maxDisplay === nextProps.maxDisplay &&
    prevProps.onClickViewAll === nextProps.onClickViewAll
  );
});

MemoizedProductListRow.displayName = 'MemoizedProductListRow';

MemoizedProductListRow.propTypes = {
  items: PropTypes.array.isRequired,
  onClickViewAll: PropTypes.func,
  maxDisplay: PropTypes.number,
};

export default MemoizedProductListRow;